import { observer } from "mobx-react-lite"

import { DisplayTokenTableValues } from "@/components/display-token-values"
import { dollarsPrettified, formatPercentage } from "@/domains/library"
import { ILiquidityPool } from "@/domains/pools"

export const PoolStakedColumn = observer(({ pool, isCompact }: { pool: ILiquidityPool; isCompact: boolean }) => {
  if (isCompact) {
    return (
      <>
        <span className="text-t100">{dollarsPrettified(pool?.gaugeUserBalanceValueUSD)}</span>{" "}
        <span className="text-t300">({formatPercentage(pool.gaugeUserBalancePercentage, 2)})</span>
      </>
    )
  }
  return (
    <>
      <>
        <span className="text-t100">{dollarsPrettified(pool?.gaugeUserBalanceValueUSD)}</span>{" "}
        <span className="text-t300">({formatPercentage(pool.gaugeUserBalancePercentage, 2)})</span>
      </>
      <DisplayTokenTableValues
        tokens={pool.tokens}
        values={[pool.gaugeUserBalanceToken0, pool.gaugeUserBalanceToken1]}
      />
    </>
  )
})
